"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isEnabled = isEnabled;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));
/**
 * **IMPORTANT**: This should only be used for complex toggle conditions where you want to intentionally avoid automated clean up. For standard use, you should use `ifFeature` instead.
 *
 * Returns `true` if the specified feature is enabled.
 */
function isEnabled(featureName) {
  try {
    if (!window?.document?.body) {
      throw Error(`The DOM has not loaded`);
    }
    // Encore is not currently a feature toggle
    if (featureName === 'encore') {
      return isEncore();
    }
    return isFeatureEnabled(featureName);
  } catch (err) {
    if (window.ENV === 'dev') {
      throw Error(`Error checking feature "${featureName}": ${err}`);
    }
    return false;
  }
}
const isFeatureEnabled = featureName => {
  var _context;
  const {
    featureToggles = ''
  } = window.document.body.dataset;
  return !!(featureName && (0, _includes.default)(_context = featureToggles.split(/\s+/g)).call(_context, featureName));
};
const isEncore = () => window.document.body.getAttribute('data-fabric-theme') === 'encore';